

export class FileDisputaDto{
  files:File[] = [];
  identifier:string = 'Arquivo sem nome';
  idCompany!:string;
}

export class FileUploadDto {
  files:File[] = [];
  portalName?: string;
  disputeOcurrenceDate?: string;
  identifier?: string;
  idCompany?:string;
}

export class BlobFileInfo {
  name: string='';
  url?: string;
  size?: number;
  lastModified?: Date;
  isFolder!: boolean;
}

export class ProposalForm
{
    proposalValidity!:string;
    deliveryDeadline!:string;
    paymentTerm!:string;
    warrantryPeriod!:string;
    bankAccountId!:string;
    unitOfMeasurement!:string;
    assignalCity!:string;
    assignalDate!:Date;
    isSigned!:boolean;
    // certificateId?:string;
    // privateKey?:string;
    additionalDeclarations!:string;
}
export class AttachmantForm
{
    title!:string;
    description!:string;
    assignalCity!:string;
    assignalDate!:Date;
    isSigned!:boolean;
    // certificateId?:string;
    // privateKey?:string;
}
export class ObjectPath{
  pathing?:string;
}

export class InfoCreateFolder{
  folderName?:string;
  filePath?:string;

}
